export default __webpack_public_path__ + "static/media/accessories-6.a80ca2d0.jpg";